<!--轮播图添加-->

<template>
  <div class="image-add-form" v-loading="loading">
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="80px"
    >
      <el-form-item label="上传图片" style="margin-top: 22px;">
        <el-upload
          class="avatar-uploader"
          :action="uploadAction"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="dataForm.src" :src="imageSrc" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="链接">
        <el-input :value="imageSrc" readonly placeholder="链接"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sortNo">
        <el-input v-model="dataForm.sortNo" placeholder="排序"></el-input>
      </el-form-item>
      <el-form-item label="是否显示">
        <el-switch
          v-model="dataForm.status"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="0"
          inactive-value="1"
        ></el-switch>
      </el-form-item>

      <el-form-item style="display: flex;flex-direction: row-reverse" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      uploadAction: this.$http.adornUrl(
        `/fileupload/upload?token=${this.$cookie.get("token")}`
      ),
      loading: false,
      dataForm: {
        id: 0,
        src: "",
        type: "",
        link: "",
        status: "0",
        sortNo: "",
      },
      dataRule: {
        src: [{ required: true, message: "图片地址不能为空", trigger: "blur" }],
        sortNo: [{ required: true, message: "排序不能为空", trigger: "blur" }],
      },
    };
  },

  mounted() {
    this.dataForm.id = this.id;
    this.$nextTick(() => {
      this.$refs["dataForm"].resetFields();
      if (this.dataForm.id) {
        this.$http({
          url: "getImageInfoById",
          method: "get",
          params: this.$http.adornParams({
            id: this.id,
          }),
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.dataForm.src = data.imageInfoById.src;
            this.dataForm.status = data.imageInfoById.status;
            this.dataForm.sortNo = data.imageInfoById.sortNo;
          }
        });
      }
    });
  },

  methods: {
    beforeAvatarUpload(file) {
      const isImage = file.type === "image/jpeg" || "image/png" || "image/jif";

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("上传头像图片只能是 JPG|png|gif 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isImage && isLt2M;
    },

    handleAvatarSuccess(res, file) {
      this.dataForm.src = res.data.url;
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http({
            url: `${this.id ? "updateImageById" : "saveImageById"}`,
            method: "post",
            data: this.$http.adornData({
              id: this.dataForm.id || undefined,
              src: this.dataForm.src,
              status: this.dataForm.status,
              sortNo: this.dataForm.sortNo,
            }),
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.onClose();
                  this.$emit("refreshDataList");
                },
              });
            } else {
              this.loading = false;
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    onClose() {
      this.$emit("close");
    },
  },
  computed: {
    imageSrc: function () {
      return this.$http.adornUrl(this.dataForm.src);
    },
  },
};
</script>


<style lang="scss">
.image-add-form {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    max-width: 100%;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    min-width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    min-width: 178px;
    height: 178px;
    display: block;
    max-width: 100% !important;
  }
  .el-input {
    width: 500px;
  }
}
.dialog-footer {
  padding: 0;
  height: 126px;
  background-color: #fafafa;
  margin: 55px 0 0 0;
  .el-button {
    line-height: 0;
  }
  .el-button--default {
    width: 70px;
    height: 34px;
    background-color: #e5e5e5;
    color: #333333;
    text-align: center;
    margin-top: 46px;
    &:hover {
      border-color: #e5e5e5;
    }
  }
  .el-button--primary {
    width: 96px;
    height: 34px;
    color: #ffffff;
    background-color: #143372;
    border-color: #143372;
    margin: 15px 30px 0 12px;
  }
}
</style>
